import { cn } from '../lib/cn';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cn('size-8', className)} aria-hidden="true">
      <rect x="4" y="8" width="56" height="44" rx="10" fill="var(--color-brand-600)" />
      <rect x="10" y="14" width="44" height="32" rx="5" fill="#fff" />
      <path
        d="M16 38c6-10 10 4 16-6s10-2 14-8"
        fill="none"
        stroke="#f9ab00"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <rect x="38" y="18" width="12" height="12" rx="2" fill="#fff176" stroke="#e0c200" />
      <path
        d="M26 52l-4 8M38 52l4 8"
        stroke="var(--color-brand-600)"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      <span className="text-lg font-semibold tracking-tight text-slate-900 dark:text-white">
        Doriav<span className="text-brand-600 dark:text-brand-400">Board</span>
      </span>
    </span>
  );
}
